function envOrDefault(key: string, fallback: string): string {
    const value = import.meta.env[key] as string | undefined;
    return value && value.trim().length > 0 ? value.replace(/\/+$/, '') : fallback;
}

function requiredEnv(key: string): string {
    const value = import.meta.env[key] as string | undefined;
    if (!value || value.trim().length === 0) {
        throw new Error(`Missing required environment variable: ${key}`);
    }
    return value.replace(/\/+$/, '');
}

export const API_URLS = {
    AUTH: requiredEnv('VITE_AUTH_API_BASE_URL'),
    PAYMENT: envOrDefault('VITE_PAYMENT_API_BASE_URL', 'https://api.orionex.id/payment-gateway'),
    LLM_LOGGER: envOrDefault('VITE_LLM_API_BASE_URL', 'https://api.orionex.id/llm-api-logger'),
    MAIL: envOrDefault('VITE_MAIL_API_BASE_URL', 'https://api.orionex.id/mail-notifier'),
    CONTENT: envOrDefault('VITE_CONTENT_API_BASE_URL', 'https://api.orionex.id/content-management/api/v1'),
} as const;
